<template>
  <h1>Ooops! 404 Page Not Found</h1>
</template>

<script>
export default {}
</script>

<style>
</style>